import React from 'react';
import { Container } from 'semantic-ui-react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import AppHeader from './components/header/appheader.component';
import RegistrationPage from './pages/registration-page/registration-page.component';

function App() {
  return (
    <Container>
      <AppHeader />
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Switch>
          <Route exact path='/registration'>
            <RegistrationPage />
          </Route>
        </Switch>
      </BrowserRouter>
    </Container>
  );
}

export default App;
